// extracted by mini-css-extract-plugin
module.exports = {"caret":"BlogMenu_caret__qgvO_"};